export default "__VITE_ASSET__fNPaMMCe__"